<template>
  <div>
    <base-crud
      crudName="Serviços Adicionais"
      newText="Novo Serviço Adicional"
      :table="table"
      :columns="columns"
      :options="options"
      :endPoint="endPoint"
      :enableAdd="true"
      :enableEdit="true"
      :enableDelete="true"
      :enableView="false"
      :dataForm="dataForm"
    ></base-crud>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "services_additionalsTable",
      // pages: [],
      // url: '',
      columns: ["id", "title", "description", "email", "company_id", "actions"],
      tableData: [
        "id",
        "title",
        "description",
        "email",
        "status",
        "company_id",
      ],
      options: {
        sortable: ["id", "title", "description", "email"],
        filterable: ["id", "title", "description", "email", "company_id"],
        filterByColumn: true,
        debounce: 1000,
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          title: "Titulo",
          description: "Descrição",
          email: "Email",
          company_id: "Empresa",
          actions: "Ações",
        },
        templates: {
          company_id: function (h, row, index) {
            return row.company ? row.company.company_name : "Sem Nome";
          },
        },
        requestFunction: function (data) {
          let requestData = {};
          let query = this.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["company"];
          return this.$http.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "services_additionals/",

      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        title: "title",
        description: "description",
        status: "status",
        email: "email",
        company_id: "company_id",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/ServicesAdditional/Crud.vue